import produce from 'immer'

import { Types } from './actions'

const INITIAL_STATE = {
  configs: {}
}

export default function configReducers (state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case Types.setConfigs: {
        draft.configs = { ...state.configs, ...action.payload?.configs }
        break
      }
      default:
    }
  })
}
